import { render } from "./view-module.vue?vue&type=template&id=48e0e06c&scoped=true"
import script from "./view-module.vue?vue&type=script&lang=js"
export * from "./view-module.vue?vue&type=script&lang=js"

import "./view-module.vue?vue&type=style&index=0&id=48e0e06c&scoped=true&lang=scss"
import "./view-module.vue?vue&type=style&index=1&id=48e0e06c&lang=css"

import exportComponent from "/home/jenkins/workspace/DeputyApp_web-hr_202604021339/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48e0e06c"]])

export default __exports__